"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEngine = void 0;
var engine_1 = require("./engine");
/**
 * Default engine instance.
 */
exports.defaultEngine = new engine_1.Engine();
//# sourceMappingURL=default-engine.js.map